import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { scrollTo } from 'lib/helpers';
import { Button } from 'components/core/Button';
import { Text } from 'components/core/Text';
import { UpArrow } from 'components/svg';
import { on, off } from 'utils/dom/dom';
import './backToTop.scss';

export function BackToTop({ offsetDistance = 300 }) {
	const [showing, setShowing] = useState(false);

	const update = useCallback(() => {
		setShowing(window.pageYOffset >= offsetDistance);
	}, [offsetDistance]);

	useEffect(() => {
		on(['resize', 'scroll'], update);
		const timer = setTimeout(update, 100);
		return () => {
			off(['resize', 'scroll'], update);
			clearTimeout(timer);
		};
	}, [update]);

	return (
		<TransitionGroup>
			{showing && (
				<CSSTransition
					timeout={500}
					classNames="transition-fade-in"
				>
					<Button
						primary={false}
						className="back-to-top"
						onClick={() => scrollTo(0)}
					>
						<UpArrow />
						<Text family="rounded">
							TOP
						</Text>
					</Button>
				</CSSTransition>
			)}
		</TransitionGroup>
	);
}

BackToTop.propTypes = {
	offsetDistance: PropTypes.number,
};

export default BackToTop;
